module.exports = __webpack_public_path__ + "img/xianjiaotongLogo.18231eb4.png";